import { Box, Button, Card, Container, Group, rem, Stack, Text } from '@mantine/core';

import {
  DecaySection,
  FeatureGridSection,
  HeroSection,
  LaunchProofSection,
  ProblemSection,
  TierStrataSection,
  UseCasesSection,
} from '@/components/organisms';
import { T } from '@/theme/assay';

/**
 * The full landing narrative, in the order the Fazier launch tells it: hook, problem,
 * what decay looks like, how the grading works, what it does, who it is for, proof, ask.
 */
export function MarketingHome() {
  return (
    <Stack gap={rem(96)} pt={rem(24)} pb={rem(64)}>
      <HeroSection />

      <ProblemSection />

      <DecaySection />

      <TierStrataSection />

      <FeatureGridSection />

      <UseCasesSection />

      <LaunchProofSection />

      <Container component="section" aria-labelledby="cta-heading" size="lg">
        <Card
          withBorder
          radius="md"
          padding="xl"
          style={{
            background: `linear-gradient(120deg, ${T.ore}15, transparent)`,
            borderColor: `var(--mantine-color-ore-8)`,
          }}
        >
          <Group justify="space-between" align="center" wrap="wrap" gap="md">
            <Stack gap="xs">
              <Box
                component="h2"
                id="cta-heading"
                style={{
                  fontFamily: '"Cormorant Garamond", serif',
                  fontWeight: 300,
                  fontSize: 'clamp(1.7rem, 3vw, 2.4rem)',
                  lineHeight: 1.15,
                  letterSpacing: '-0.02em',
                  color: T.textPrimary,
                  margin: 0,
                }}
              >
                Ready to stop losing touch?
              </Box>
              <Text size="sm" c="dimmed" maw={520}>
                Start free, import your network, and let Assay remind you who to reconnect with -
                with the message already drafted. Upgrade any time without losing your history.
              </Text>
            </Stack>
            <Group gap="sm">
              <Button size="md" component="a" href="/signup">
                Start for free
              </Button>
              <Button size="md" variant="outline" component="a" href="/pricing">
                View pricing
              </Button>
            </Group>
          </Group>
        </Card>
      </Container>
    </Stack>
  );
}
